<template>

  <select v-model="selected" @change="$emit('update:modelValue', this.selected)" class="form-control form-control-sm">
    <option v-for="schedule in schedules" :value="schedule">{{ schedule.name }}</option>
  </select>

</template>

<script>
export default {
  name: "TpaFeeScheduleSelector",
  props: {
    schedules: {
      type: Array,
      required: true
    },
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.modelValue
    }
  }
}
</script>

<style scoped>

</style>
